import _ from 'lodash';

import api from 'mixins/api';

export default {
  mixins: [
    api
  ],
  props: {
    details: {
      type: Object,
      default () {
        return {
          id: null,
          enabled: false,
          requisites: {}
        };
      }
    }
  },
  data () {
    return {
      saving: false
    };
  },
  methods: {
    save () {
      let data = Object.assign({}, this.details);

      data.requisites = JSON.stringify(data.requisites);
      this.saving = true;
      this.api.put(`/payment-details/${this.details.id}`, data).then(response => {
        this.$q.notify({
          message: 'Сохранено',
          type: 'positive'
        });
        this.$emit('save');
        this.saving = false;
      }).catch(error => {
        _.forOwn(error.response.data.errors, (value, key) => {
          this.$q.notify({message: value[0], type: 'negative'});
        });
        this.saving = false;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/ServiceProviderSetting/methods/mixins/harvester.js